import { render, staticRenderFns } from "./SearchIndex.vue?vue&type=template&id=7b5f87cb&"
import script from "./SearchIndex.vue?vue&type=script&lang=ts&"
export * from "./SearchIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../_locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fsearch%2FSearchIndex.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/views/search/SearchIndex.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fsearch%2FSearchIndex.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "../../components/_locales/Organs.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fsearch%2FSearchIndex.vue"
if (typeof block2 === 'function') block2(component)

export default component.exports